<template>
  <div>
    <search-and-table-part
      :pagination="pagination"
      @getItems="getItems"
      @trdbClicked="checkItem"
      :items="items"
      :columns="columns"
      :idProperty="idProperty"
      :nameProperty="nameProperty"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :hasCheckDetail="true"
      :getTrigger="getTrigger"
    >
      <template slot="searchArea">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group d-flex col-12 p-0">
              <label
                for="searchBusinessId"
                class="col-3 col-form-label col-md-4 col-lg-3 col-xl-2"
                >營業人編號:</label
              >
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  id="searchBusinessId"
                  v-model="searchDTO.BusinessId"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <date-range-part
              :date="dateRange"
              :gridDegree="6"
              @dateChanged="dateChanged"
            />
          </div>
          <div class="col-12 col-md-6">
            <input-inline-part
              id="searchApiType"
              :labelText="`${$t('searchAndTablePart.apitype')}:`"
              :gridDegree="6"
            >
              <select
                id="searchApiType"
                class="form-control"
                v-model="searchDTO.ApiType"
              >
                <option
                  v-for="apiType in apiTypes"
                  :key="apiType.value"
                  :value="apiType.value"
                >
                  {{ apiType.text }}
                </option>
              </select>
            </input-inline-part>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group d-flex col-12 p-0">
              <label
                for="searchStatusCode"
                class="col-3 col-form-label col-md-4 col-lg-3 col-xl-2"
                >狀態碼:</label
              >
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  id="searchStatusCode"
                  v-model="searchDTO.StatusCode"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="dataButtonAreaFront" slot-scope="props">
        <button
          class="btn btn-outline-primary btn-icon"
          type="button"
          @click="checkItem(items[props.index])"
        >
          <i class="fas fas fa-eye"></i>
        </button>
      </template>
    </search-and-table-part>
    <log-data
      :modalId="modalId"
      :item="item"
      :columns="columns"
      :isShow="isShow"
      @onClosed="onClosed"
    ></log-data>
  </div>
</template>

<script>
import searchAndTablePart from "@/components/parts/searchAndTablePart";
import dateRangePart from "@/components/parts/dateRangePart";
import inputInlinePart from "@/components/parts/inputInlinePart";
import logData from "@/components/datas/LogData";

import date from "@/filters/date";

export default {
  data() {
    return {
      items: [],
      item: {},
      columns: [
        { name: "CreateTime" },
        { name: "BusinessId" },
        { name: "TerminalId" },
        { name: "ApiTypeText" },
        { name: "RequestURL" },
        { name: "RequestMethod" },
        { name: "ResponseCode" },
        { name: "IsSuccessText" },
        { name: "DurationTime" },
      ],
      apiTypes: this.$enum.apiType.getAll(),
      searchDTO: {},
      pagination: {},
      idProperty: "Id",
      nameProperty: "",
      dateRange: {
        DayBegin: "",
        DayEnd: "",
      },
      isShow: false,
      modalId: "ErrorMessage",
      getTrigger: false,
    };
  },
  components: {
    searchAndTablePart,
    dateRangePart,
    inputInlinePart,
    logData,
  },
  methods: {
    getItems(dTO) {
      this.searchDTO.DayBegin = this.dateRange.DayBegin;
      this.searchDTO.DayEnd = this.dateRange.DayEnd;
      const d = { ...dTO, ...this.searchDTO };
      this.$api.logs.getErrorMessages(d).then((data) => {
        this.items = data.Datas;
        this.items.forEach((item) => {
          if (item.IsSuccess) {
            item.IsSuccessText = "是";
          } else {
            item.IsSuccessText = "否";
          }
          item.ApiTypeText = this.$enum.apiType.getByValue(item.ApiType).text;
        });
        this.pagination = data.Pagination;
      });
    },
    checkItem(i) {
      this.$api.logs.getErrorMessage(i.Id).then((data) => {
        this.item = data;
        if (this.item.IsSuccess) {
          this.item.IsSuccessText = "是";
        } else {
          this.item.IsSuccessText = "否";
        }
        this.item.ApiTypeText = this.$enum.apiType.getByValue(
          this.item.ApiType
        ).text;
        this.item.DurationTime += "s";
        this.isShow = !this.isShow;
      });
    },
    onClosed() {
      this.isShow = !this.isShow;
    },
    dateChanged(begin, end) {
      this.dateRange.DayBegin = begin;
      this.dateRange.DayEnd = end;
    },
  },
};
</script>
